
<template >
  <div class="bg-beige" style="min-height:100vh;">
    <div class="flexi">
      <tbl_nm v-if="$route.name=='RoomAgentLogin' || $route.name=='RoomAgentOTP'">
        <cl class="vm w50 l">
          <img src="@/assets/imgs/web/logo.svg" alt="" loading="lazy" class="wa header-logo" data-aos="fade-right" data-aos-delay="100">
        </cl>
        <cl class="vm w50 r">
          <img src="@/assets/imgs/reg/orgBy.png" alt="" loading="lazy" class="wa header-logo" data-aos="fade-left" data-aos-delay="100">
        </cl>
      </tbl_nm>
      <div  v-if="$route?.meta?.requiresAgentAuth==true" class="r pv15">
        <tbl_nm>
          <cl class="w50 l vm">
          </cl>
          <cl class="w50 r vm">
            <button class="goBackButton" @click="logout">
              <span class="vm">Logout</span>
              <svg class="vm ml5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#EEEEE1" d="m17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4z" stroke-width="1" stroke="#EEEEE1"/></svg>
            </button>
          </cl>
        </tbl_nm>
      </div>
    </div>
    <div class="">
      <router-view></router-view>
    </div>
  </div>
  <div class="pf ov bgb10 " v-if="$store.state.loader==1" style="z-index: 9999999;">
     <div class="cc c">
      <span class="mainloader"></span>
     </div>
  </div>
  <!-- <div class="pf ov bgb10 " v-if="$store.state.loader==1" style="z-index: 9999999;">
    <img src="@/assets/imgs/loader.gif" alt="" class="cc" style="width: 100px;">
  </div> -->
  <div class="pf ov bgb50 " v-if="$store.state.showPopUp" style="z-index: 9999999;">
    <div class="cc w90 popUp oya" >
      <div v-if="$store.state.apiStatus==true" class="c">
        <img src="@/assets/imgs/reg/check.svg" alt="" class="w100" style="width: 100px;">
        <p class="c-brown-dark fs20">{{ $store.state.popUpMessage }}</p>
        <div class="c mt20"><div class="g_nm w100 goBackButton mt30" @click="close(1)" style="max-width: 200px;">Ok</div></div>
      </div>
      <div v-if="$store.state.apiStatus==false">
        <p class="c-brown-dark fs20">{{ $store.state.popUpMessage }}</p>
        <div class="c mt20"><div class="g_nm w100 goBackButton mt30" @click="close(0)" style="max-width: 200px;">Ok</div></div>
      </div>
    </div>
  </div>
  <div class="pf ov bgb50 " v-if="showSessionExpiredPopup" style="z-index: 9999999;">
    <div class="cc w90 popUp oya" >
        <p class="c-brown-dark fs20">Session Expired. <br> please log in again.</p>
        <div class="c mt20"><div class="g_nm w100 goBackButton mt30" @click="kickOut()" style="max-width: 200px;">Login</div></div>
    </div>
  </div>
</template>

<script>
import Select2 from "vue3-select2-component";
import '@/assets/css/regStyle.css'

  export default {
    name: "DashboardLayout",
    components: {
      Select2
    },
    data(){
      return{
        errorTimeouts: {},
        showSessionExpiredPopup: false
      }
    },
        mounted() {
      $('body').removeClass('rtl');
      this.$i18n.locale='en';
      $('html').attr('lang','en');

    },
    methods: {
      kickOut(){
        this.$store.state.loader = 1;
        this.showSessionExpiredPopup = false;
        $('html').removeClass('oh');
        this.$cookies.remove('_al_RAgtu');
        this.$store.state.loader = 0;
        this.$router.push({ name: 'RoomAgentLogin' });
      },
      logout(){
        this.showSessionExpiredPopup = false;
        $('html').removeClass('oh');
        this.$store.state.loader = 1;
        this.$cookies.remove('_al_RAgtu');
        this.$store.state.loader = 0;
        this.$router.push({ name: 'RoomAgentLogin' });
      },
      sessionExpired(){
        this.showSessionExpiredPopup = true;
        $('html').addClass('oh');
      },
      arWithSpace(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        const regex = /^[\u0600-\u06FF\s]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only Arabic letters and spaces are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      enWithSpace(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        const regex = /^[a-zA-Z\s]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only English letters and spaces are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      enWithoutSpace(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        const regex = /^[a-zA-Z]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only English letters are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      checkNoSpical(e) {
        // Prevent special characters
        const regex = /[^a-zA-Z0-9\s]/;
        if (regex.test(e.key)) {
          e.preventDefault();
        }
      },
      checkNoSpicalNoSpace(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        const regex = /[^a-zA-Z0-9]/;
        if (regex.test(e.key)) {
          errorDiv.text('Only English letters and numbers are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      handlePaste(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        errorDiv.text('Pasting is not allowed.');
        errorInput.addClass('error');
        // errorDiv.slideDown();
        if (this.errorTimeouts[errorClass]) {
          clearTimeout(this.errorTimeouts[errorClass]);
        }
        this.errorTimeouts[errorClass] = setTimeout(() => {
          // errorDiv.slideUp();
          errorInput.removeClass('error');
          this.errorTimeouts[errorClass] = null;
        }, 3000);
        // e.preventDefault();
      },
      preventCopy(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        errorDiv.text('Copy/Cut is not allowed.');
        errorInput.addClass('error');
        // errorDiv.slideDown();
        if (this.errorTimeouts[errorClass]) {
          clearTimeout(this.errorTimeouts[errorClass]);
        }
        this.errorTimeouts[errorClass] = setTimeout(() => {
          // errorDiv.slideUp();
          errorInput.removeClass('error');
          this.errorTimeouts[errorClass] = null;
        }, 3000);
        // e.preventDefault();
      },
      allowedEmailChar(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        const regex = /^[a-zA-Z0-9@._+\-]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only english letters, numbers and @ . _ - are allowed in email.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      onlyNumbers(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        const regex = /^[0-9]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only numbers are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      enarSpaceDash(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        // Allow English letters, Arabic letters, spaces, and -
        const regex = /^[a-zA-Z\u0600-\u06FF\s-]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only English and Arabic letters, spaces and - are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      enSpaceNumChar(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        // Allow English letters, numbers, spaces, #, and -
        const regex = /^[a-zA-Z0-9\s-]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only English letters, numbers, spaces and - are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      validatedata(formname, errorClass, text) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        if (formname == "" || formname == null ) {
          $(errorDiv).html(text);
          $(errorDiv).slideDown();
          $(errorInput).addClass('error');
          return 0;
        } else {
          $(errorInput).removeClass('error');
          $(errorDiv).slideUp();
          return 1;
        }
      },
      checkEnArSpaceDash(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        // Allow English letters, Arabic letters, spaces, and -
        const regex = /^[a-zA-Z\u0600-\u06FF\s-]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only English and Arabic letters, spaces and - are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      close(stauts){
        if(stauts==0){
          this.$store.state.showPopUp=false;
        }
        else{
          this.$store.state.showPopUp=false;
          this.$router.push({ name: 'ProfileDashboard' });
        }
      }
    },    
    provide() {
      return {
        checkNoSpical: this.checkNoSpical,
        handlePaste: this.handlePaste,
        preventCopy: this.preventCopy,
        enWithSpace: this.enWithSpace,
        arWithSpace: this.arWithSpace,
        allowedEmailChar: this.allowedEmailChar,
        onlyNumbers: this.onlyNumbers,
        validatedata: this.validatedata,
        enSpaceNumChar: this.enSpaceNumChar,
        enWithoutSpace: this.enWithoutSpace,
        checkNoSpicalNoSpace: this.checkNoSpicalNoSpace,
        enarSpaceDash: this.enarSpaceDash,
        logout: this.logout,
        checkEnArSpaceDash: this.checkEnArSpaceDash,
        sessionExpired: this.sessionExpired


      };
    }
  }
</script>
<style scoped>
  .myLabel{
  color: var(--brown-dark);
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  margin-bottom: 8px;
  display: block;
}
.myInput{
  width: 100%;
  padding: 8px 16px;
  border: 1px solid #CCCCCC;
  border-radius: 0.25rem;
  font-size: 18px;
  font-weight: 400;
  background-color: var(--beige-light);
  color: var(--brown-dark);
}
.myInput::placeholder{
  color: var(--brown-medium-placeholder);
}
.myInput:focus{
  outline: none;
  border-color: var(--brown);
}
.myInput.error{
  border-color: #f14343;
}
.error.alulaSelect .select2-selection{
  border-color: #f14343 !important;
}
.error_message{
  font-size: 14px;
  color: #f14343;
  text-align: left;
  font-family: Marine Rounded !important;
  font-weight: 600;
  display: none;
  padding-top: 6px;
}
.redStar{
  color: #f14343;
}
</style>